import { getRefreshToken, setAuthTokens } from './authTokenStorage';
import { refreshAuthWithRefreshToken } from './cognitoAuthApi';
import { getSessionRealm } from './sessionRealm';

import type { AuthResult } from './types';

let inflightRefresh: Promise<AuthResult | null> | null = null;

/**
 * Refreshes Cognito tokens using the stored refresh token.
 * Uses a single in-flight promise so concurrent 401s do not trigger multiple refresh calls.
 */
export async function refreshSessionTokens(): Promise<AuthResult | null> {
  if (inflightRefresh) {
    return inflightRefresh;
  }

  inflightRefresh = (async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      return null;
    }

    const result = await refreshAuthWithRefreshToken(refreshToken);
    const realm = getSessionRealm() ?? 'user';
    const resultWithRefreshToken = {
      ...result,
      refreshToken: result.refreshToken ?? refreshToken,
    };
    setAuthTokens(resultWithRefreshToken, realm);
    return resultWithRefreshToken;
  })();

  try {
    return await inflightRefresh;
  } finally {
    inflightRefresh = null;
  }
}
